import {
  BottomSheetBackdrop,
  type BottomSheetBackdropProps,
  BottomSheetModal,
  BottomSheetView,
} from '@gorhom/bottom-sheet';
import { Image } from 'expo-image';
import { StyleSheet } from 'react-native-unistyles';
import {
  type ChatMessageActionSheetData,
  useChatDetailContext,
} from '@/components/Chat/ChatDetailContext';
import Box from '@/components/UI/Box';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';

const SNAP_POINTS = ['40%'];

function ChatMessageSheet() {
  const bottomSheetRef = useChatDetailContext((state) => state.bottomSheetRef);
  const backdrop = (props: BottomSheetBackdropProps) => (
    <BottomSheetBackdrop appearsOnIndex={0} disappearsOnIndex={-1} {...props} />
  );
  return (
    <BottomSheetModal<ChatMessageActionSheetData>
      backdropComponent={backdrop}
      ref={bottomSheetRef}
      index={1}
      snapPoints={SNAP_POINTS}
      backgroundStyle={styles.sheetBackground}
      handleIndicatorStyle={styles.handleIndicator}
    >
      {(modalData) => {
        const actionSheetData = modalData?.data;

        return (
          <BottomSheetView>
            <Box flex style={styles.content}>
              {actionSheetData?.isImage ? (
                <Image
                  transition={500}
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 16,
                  }}
                  source={{
                    uri: actionSheetData.content || undefined,
                  }}
                />
              ) : actionSheetData?.content ? (
                <Text center numberOfLines={1}>
                  {actionSheetData.content}
                </Text>
              ) : null}

              {actionSheetData?.map((button) => (
                <Item key={button.name} onPress={button.handler}>
                  <Icon name={button.icon} />
                  <Text>{button.text}</Text>
                </Item>
              ))}
            </Box>
          </BottomSheetView>
        );
      }}
    </BottomSheetModal>
  );
}
export default ChatMessageSheet;
const styles = StyleSheet.create((theme) => ({
  content: {
    backgroundColor: theme.colors.surface,
  },
  handleIndicator: {
    backgroundColor: theme.colors.surfaceMuted,
  },
  sheetBackground: {
    backgroundColor: theme.colors.surface,
  },
}));
